<template>
    <div>
        <header
            class="header"
            :style="{
                height: `calc( ${height}/1920 * ${screenWidth}px)`,
                'background-image': `url(${bannerImg})`,
                'background-size': '100% 100%',
            }"
        >
            <div class="top" :style="topColor">
                <div>
                    <div>
                        <img
                            src="../../assets/images/index/WL-logo.png"
                            alt=""
                        />
                        四川省文学艺术界联合会｜专家评审平台
                    </div>
                    <ul>
                        <li
                            :class="
                                activeNav === nav_item.name
                                    ? 'nav activeNav'
                                    : 'nav'
                            "
                            v-for="(nav_item, nav_index) in navList"
                            :key="nav_index"
                            @click="changeActive(nav_item.url)"
                        >
                            {{ nav_item.name }}
                        </li>
                    </ul>
                    <div v-if="userName == ''" @click="toLogin">登陆/注册</div>
                    <div
                        v-else-if="userName !== null"
                        :class="userActive === true ? 'activeNav' : ''"
                        @click="toUser"
                    >
                        {{ userName }}
                    </div>
                    <div
                        v-else
                        :class="userActive === true ? 'activeNav' : ''"
                        @click="toUser"
                    >
                        个人中心
                    </div>
                </div>
            </div>

            <div class="title">
                <h1>
                    <!-- {{ match_detail.name }}-{{ match_detail.group_detail.name }} -->
                    
                    </h1>
                <p>
                    <!-- {{ match_detail.join_msg }} -->
                </p>
                <div class="btns">
                    <div
                        v-if="
                            match_detail.group_detail.info_time.now_status !== null &&
                            match_detail.group_detail.info_time.now_status.type !== 0 &&
                            match_detail.group_detail.info_time.now_status.type !== 1
                        "
                        class="btn"
                    >
                        {{ match_detail.group_detail.info_time.now_status.name }}中
                    </div>
                    <div
                        v-else-if="
                             match_detail.group_detail.info_time.now_status !== null &&
							 match_detail.group_detail.info_time.now_status.type == 0
                        "
                        class="btn"
                        @click="toJoin"
                    >
                        我要参赛
                    </div>
                    <div
                        v-else-if="
                            match_detail.group_detail.info_time.time_end_num 
							<  match_detail.group_detail.info_time.now_time
                        "
                        class="btn disable"
                    >
                        比赛已结束
                    </div>
                    <div
                        class="btn"
                        v-show="btnType === 'detail'"
                        @click="toDetail"
                    >
                        查看详情
                    </div>
                        <div
                        class="btn"
                        v-if="match_detail.left_type == 1"
                        @click="toworks(match_detail.left.id,match_detail.left.group_id)"
                    >
                        上一阶段
                    </div>
                    <div
                        class="btn"
                        v-if="match_detail.right_type == 1"
                        @click="toworks(match_detail.right.id,match_detail.right.group_id)"
                    >
                        下一阶段
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import Storage from "../../xx-vue/utils/storage";
import MatchServices from "../../xx-vue/services/match";
import {getNavigationList} from "../../xx-vue/services/banner";
export default {
    props: {
        activeNav: {
            type: String,
        },
        //.top背景色
        topColor: {
            type: String,
        },
        //按钮类型
        btnType: {
            type: String,
        },
        //是否激活用户
        userActive: {
            type: Boolean,
            default: false,
        },
        //banner高度
        height: {
            type: Number,
        },
    },
    data() {
        return {
            //导航列表
            navList: [
                // { name: "首页", path: "/" },
                // { name: "艺讯", path: "/art_info" },
                // { name: "比赛评选", path: "/match" },
                // { name: "评审专家库", path: "/expert" },
                // {
                //     name: "数字艺术馆",
                //     path: "http://sz.scwyy.cn/home/index.html",
                // },
                // { name: "联系我们", path: "/contactUs" },
            ],
            match_detail: {
                contest_time: {
                    now_status: null,
                },
                group_detail:{
                    "info_time":{
                        "now_status":{}
                    }
                },
            },
            //用户名
            userName: "",
            screenWidth: document.body.clientWidth, //屏幕宽度
            bannerImg: require("../../assets/images/match/WL-BS-banner-normol.png"),
            userInfo: {
                expert_info: {
                    id: undefined,
                },
            },
        };
    },

    watch: {
        $route: {
            handler(val, oldval) {
                this.initData(~~val.query.project_id, ~~val.query.group_id); //新路由信息
            },
            // 深度观察监听
            deep: true,
        },
    },

    mounted() {
        const userInfo = Storage.getStorage("info");
        if (userInfo) {
            this.userInfo = userInfo;
            if (userInfo.name !== undefined) {
                this.userName = userInfo.name;
            }
        }

        const project_id = ~~this.$route.query.project_id;
        const group_id = ~~this.$route.query.group_id;
        this.initData(project_id, group_id);
		this.getNavigationData();
    },

    methods: {
        //跳转登录
        toLogin() {
            this.$router.push("/login");
        },
		//获取导航栏数据
		getNavigationData(){
			getNavigationList().then((api_res)=>{
				this.navList = api_res.data.data;
			})
		},
        //nav跳转
        changeActive(path) {
            if (path !== "http://sz.scwyy.cn/home/index.html") {
                this.$router.push(path);
            } else {
                window.open(path);
            }
        },
        //跳转详情
        toDetail() {
            this.$router.push(
                `/match/match_detail?project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
            );
        },
        toworks(id,group_id){
            this.$router.push(
                `/match/match_works?project_id=${id}&group_id=${group_id}`
            );
            location.reload()
        },
        //跳转榜单
        toTop() {
            this.$router.push(
                `/match/match_top?project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
            );
        },
        //跳转个人中心
        toUser() {
            this.$router.push("/user");
        },
        //跳转参赛
        async toJoin() {
            const result = await MatchServices.getIsSign({
                group_id: ~~this.$route.query.group_id,
                project_id: ~~this.$route.query.project_id,
            });
            if (result.code == 600) {
                var fullPath = this.$route.fullPath;
                this.$router.push("/login?url="+encodeURIComponent(fullPath));
            }
            if (result.code == 200) {
                var data = result.data;
                if (data.un_pass) {
                    this.$router.push(
                        `/match/join_match?project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
                    );
                } else {
                    this.$router.push(
                        `/match/upload_work?project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
                    );
                }
            } else if (result.code == 0) {
            }
        },
        //获取比赛详情
        async initData(id, group_id) {
            const result = await MatchServices.getDetailAsync({
                id: id,
                group_id: group_id,
            });
            this.match_detail = result.data.data;
            if (result.data.data.img_banner_full) {
                this.bannerImg = result.data.data.img_banner_full;
            }
            const group = this.match_detail.list_group.filter(
                (v) => v.id === group_id
            );
			var group_detail = group[0] || {};
            
			group_detail['info_time']['time_end_num'] = new Date(group_detail.info_time.time_end).getTime()/1000;
			this.match_detail.group_detail = group_detail;
        },
    },
};
</script>

<style lang="less" scoped>
.header {
    width: 100%;
    .top {
        padding: 26px 0;
        background-color: rgba(0, 0, 0, 0.3);
        color: #ffffff;
        position: fixed;
        width: 100%;
        box-sizing: border-box;
        z-index: 99;

        & > div {
            display: flex;
            align-items: center;
            width: 1200px;
            margin: 0 auto;
            & > :first-child {
                font-size: 14px;
                margin-right: 10%;
                display: flex;
                align-items: center;
                user-select: none;

                img {
                    width: 38px;
                    height: 38px;
                    margin-right: 4px;
                }
            }

            & > :last-child {
                cursor: pointer;
            }

            .nav {
                font-weight: bold;
            }

            li {
                cursor: pointer;
                margin-right: 40px;
            }

            ul {
                display: flex;
            }

            .activeNav {
                color: #f2252f;
                position: relative;

                &::before {
                    content: "";
                    display: block;
                    width: 1px;
                    height: 16px;
                    background-color: #f2252f;
                    position: absolute;
                    top: -18px;
                    left: 48%;
                }

                &::after {
                    content: "";
                    display: block;
                    width: 1px;
                    height: 16px;
                    background-color: #f2252f;
                    position: absolute;
                    bottom: -18px;
                    left: 48%;
                }
            }
        }
    }

    .title {
        padding-top: 120px;
        height: 100%;
        text-align: center;
        h1 {
            color: #ffffff;
            font-size: 260%;
            font-family: "Microsoft YaHei Bold";
            margin-bottom: 24px;
        }
        p {
            width: 800px;
            margin: 0 auto;
            line-height: 30px;
            color: #ffffff;
            margin-bottom: 1.5%;
        }

        .btns {
            display: flex;
            justify-content: center;
            div {
                padding-left: 30px;
                padding-right: 30px;
                padding-top: 10px;
                padding-bottom: 10px;
            }
			.btn{
				margin: 0px 20px;
				background: url("../../assets/images/match/bs-button-normol@2x.png")
				    no-repeat;
				background-size: 100% 100%;
				color: #ffffff;
				cursor: pointer;
				&.disable{
					background: url("../../assets/images/match/bs-button-disable@2x.png")
					    no-repeat;
				}
			}
            margin-top:9%;
        }
    }
}
</style>
